export default __webpack_public_path__ + "static/individual.eglo-b2b-5e076879bcfffeb17a82903078ec7d96.webp";